import React from "react";
import { Card, List, Typography } from "antd";

const { Text } = Typography;

// 置頂公告
const pinnedAnnouncement = {
    date: "2025-02-16",
    details: [
        "📢 新增名單資料請填寫表單: https://reurl.cc/36ng8R",
        "📢 目前僅提供黑名單查詢，名單陸續新增中，歡迎填寫表單。",
        "📢 網站營運需要成本，歡迎乾爸乾媽來信贊助廣告位！",
        "📢 團隊聯絡方式: protectanimalofficial@gmail.com",
    ],
};

// 其他公告（時間排序，最新在最上方）
const announcements = [
    { date: "2026-04-25", details: ["🎉 新增可愛貓頭鷹作為社團吉祥物"] },
    { date: "2026-04-10", details: ["🎉 新增醫療科普文章跟社團聲明"] },
    { date: "2025-02-15", details: ["🎉 優化文字內容"] },
    { date: "2025-01-28", details: ["🎉 新增名單查詢功能", "🔧 優化 UI 設計"] },
].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

// 函數: 檢測文字中是否有 URL 或 Email，並轉換為可點擊的連結
const renderTextWithLinksAndEmails = (text: string): React.ReactNode[] => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

    return text.split(/(\s+)/).map((part: string, index: number) => {
        if (urlRegex.test(part)) {
            return (
                <a
                    key={index}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#1890ff", textDecoration: "underline" }}
                >
                    {part}
                </a>
            );
        } else if (emailRegex.test(part)) {
            return (
                <a
                    key={index}
                    href={`mailto:${part}`}
                    style={{ color: "#1890ff", textDecoration: "underline" }} // 这里改成蓝色
                >
                    {part}
                </a>
            );
        }
        return part;
    });
};

const News = () => {
    return (
        <div style={{ padding: 20, display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            {/* 置頂公告 */}
            <Card style={{ background: "#fffbe6", border: "1px solid #faad14", marginBottom: 20 }}>
                <Text strong style={{ fontSize: "16px", color: "#d48806" }}>
                    🔥 重要公告
                </Text>
                <Text type="secondary" style={{ display: "block", marginTop: 5 }}>
                    {pinnedAnnouncement.date}
                </Text>
                <ul style={{ marginTop: 10 }}>
                    {pinnedAnnouncement.details.map((detail, index) => (
                        <li key={index}>{renderTextWithLinksAndEmails(detail)}</li>
                    ))}
                </ul>
            </Card>

            {/* 其他公告 */}
            <List
                grid={{ gutter: 16, column: 1 }}
                dataSource={announcements}
                renderItem={(item) => (
                    <List.Item>
                        <Card>
                            <Text type="secondary">{item.date}</Text>
                            <ul style={{ marginTop: 10 }}>
                                {item.details.map((detail, index) => (
                                    <li key={index}>{renderTextWithLinksAndEmails(detail)}</li>
                                ))}
                            </ul>
                        </Card>
                    </List.Item>
                )}
                style={{ flexGrow: 1 }}
            />
        </div>
    );
};

export default News;
